<template lang="html">
<div v-if="data">
  <survey-climate v-if="data.survey.type === 'extended' || data.survey.type ==='labor'"></survey-climate>
  <survey-mailing v-if="data.survey.type === 'custom' || data.survey.type ==='mailing'"></survey-mailing>
</div>    
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SurveyMailing from './SurveyMailing.vue';
import SurveyClimate from './SurveyClimate.vue';


Vue.use(BootstrapVue);
export default {
  components: {
    SurveyMailing,
    SurveyClimate,
  },
  data: () => {
    return {
      data: null,
      contact_id: null,
      survey_id: null,
      round_id: null,
      score: null,
      email: null,
      loader: false,
    };
  },
  
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.contact_id = this.$route.params.contact_id;
      this.survey_id = this.$route.params.survey_id;
      this.round_id = this.$route.params.round_id;
      this.score = this.$route.params.score;
      this.email = this.$route.params.email;
      let url = 'survey/' + this.contact_id + '/' + this.round_id + '/' + this.email;
      if (this.score) {
        url += '/' + this.score;
      }
      axios.get(url).then(response => {
        this.data = response.data.data;
        /* set value to email click */ 
        
      }).catch(error => {
        this.loader = false;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/surveys/App.vue